import classNames from 'classnames';
import ContentLoader from 'react-content-loader';

import styles from './_index.module.scss';

export interface LoaderSkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  height?: number;
  width?: number;
  isAnimated?: boolean;
}

const LoaderSkeleton = ({
  children,
  className,
  height = 300,
  isAnimated = true,
  width = 1333,
}: LoaderSkeletonProps) => {
  return (
    <ContentLoader
      animate={isAnimated}
      backgroundColor="var(--color-background-medium)"
      className={classNames(styles['loader-skeleton'], className)}
      data-testid="loader-skeleton"
      foregroundColor="var(--color-background-heavy)"
      height={height}
      width={width}
    >
      {children}
    </ContentLoader>
  );
};

export default LoaderSkeleton;
